var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup386(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_386",
    "data-name": "Group 386",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.637,
    height: 15,
    viewBox: "0 0 20.637 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 20.637,
    height: 15,
    fill: "#d10a11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M7.937,9.525a3.044,3.044,0,0,1,.19-.239Q12.4,5.005,16.684.728A2.284,2.284,0,0,1,20.028,3.84q-.072.078-.147.153L9.631,14.243a2.226,2.226,0,0,1-2.514.591,2.415,2.415,0,0,1-.818-.542Q3.5,11.52.719,8.722A2.206,2.206,0,0,1,.112,6.393,2.156,2.156,0,0,1,1.883,4.822a2.2,2.2,0,0,1,2.051.652q1.8,1.8,3.589,3.6c.129.13.25.268.415.446",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup386);
export default __webpack_public_path__ + "static/media/Group 386.8ddcbedf55f49c03b19f42cb0feebf92.svg";
export { ForwardRef as ReactComponent };